module.exports = __webpack_public_path__ + "static/media/galway-5.03d43855.jpg";